import { UserToken } from 'domain/entities/UserEntity';

export class AppSocket {
    private socket: WebSocket | null;
    constructor() {
        this.socket = null;
    }

    connect(url: string) {
        if (!this.socket) {
            this.socket = new WebSocket(url);
        }
    }

    initSocketAttributes = (user: UserToken) => {
        if (!this.socket || this.socket.readyState !== WebSocket.OPEN) return;
        const data = {
            action: 'setAttributes',
            memberId: user.user?.id ?? '',
            memberType: 0,
        };
        this.socket.send(JSON.stringify(data));
    };

    disconnect() {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.close();
            this.socket = null;
        }
    }

    send(message: any) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(message);
        }
    }

    on(eventName: string, callback: (event: any) => void) {
        if (this.socket) {
            this.socket.addEventListener(eventName, (event) => {
                callback(event);
            });
        }
    }
}
